import { staticUrl } from '@/config';
import {
  buttonsMapToFrontend,
  carouselCommerceToFrontend,
  carouselFeedToFrontend,
  commerceToFrontend,
  couponToFrontend,
  premiumVideoToFrontend,
  wideItemListToFrontend,
  brandWideItemListToFrontend,
  brandCommerceToFrontend,
  brandCarouselFeedToFrontend,
  brandCarouselCommerceToFrontend,
  brandPremiumVideoToFrontend,
} from '@/utils/convertData';
import { getImageInfo } from '@/utils/getImageInfo';

const setDefaultMessageData = async (item) => {
  const result = {
    content: item.content,
  };

  result.image = {};

  if (item.imageId) {
    const {
      name,
      type,
      width,
      height,
    } = await getImageInfo({
      id: item.imageId,
      imageType: 'friendtalk',
    });

    result.image = {
      id: item.imageId,
      link: item.imageLink || '',
      name,
      type,
      width,
      height,
      url: `${staticUrl}/kakaofriendtalk/${item.imageId}`,
    };
  }

  result.buttons = (item.buttons ?? []).map(buttonsMapToFrontend);
  result.coupon = couponToFrontend(item.coupon);

  return result;
};

const setBrandDefaultMessageData = async (item) => {
  const temp = item;
  temp.image = {};

  if (item.imageId) {
    const response = await getImageInfo({
      id: item.imageId,
      imageType: 'brand',
    });

    temp.image = {
      id: item.imageId,
      width: response.width,
      height: response.height,
      type: response.type,
      name: response.name,
      link: item.imageLink || '',
      url: `${staticUrl}/kakaobrandtalk/${item.imageId}`,
    };
  }

  temp.buttons = (item.buttons ?? []).map(buttonsMapToFrontend);
  temp.coupon = couponToFrontend(item.coupon);

  return temp;
};

export default async (item) => {
  const { messageType } = item;
  const result = { messageType };

  switch (messageType) {
    case 'SMS':
    case 'LMS':
      result.textmessage = {
        content: item.content,
        subject: item.subject,
        image: {},
      };
      break;
    case 'MMS':
      result.textmessage = {
        content: item.content,
        subject: item.subject,
        image: {
          ...await getImageInfo({
            id: item?.imageId,
            imageType: 'textmessage',
          }),
          type: 'MMS_IMAGE',
          id: item?.imageId,
          url: `${staticUrl}/textmessage/${item?.imageId}`,
        },
      };
      break;
    case 'FRIENDTALK_TEXT':
    case 'FRIENDTALK_IMAGE':
    case 'FRIENDTALK_WIDE_IMAGE':
      result.friendtalkDefault = await setDefaultMessageData(item);
      break;
    case 'FRIENDTALK_WIDE_ITEM_LIST':
      result.friendtalkWideItemList = await wideItemListToFrontend(item);
      break;
    case 'FRIENDTALK_COMMERCE':
      result.friendtalkCommerce = await commerceToFrontend(item);
      break;
    case 'FRIENDTALK_CAROUSEL_FEED':
      result.friendtalkCarouselFeed = await carouselFeedToFrontend(item);
      break;
    case 'FRIENDTALK_CAROUSEL_COMMERCE':
      result.friendtalkCarouselCommerce = await carouselCommerceToFrontend(item);
      break;
    case 'FRIENDTALK_PREMIUM_VIDEO':
      result.friendtalkPremiumVideo = await premiumVideoToFrontend(item);
      break;
    case 'BRANDTALK_TEXT':
    case 'BRANDTALK_IMAGE':
    case 'BRANDTALK_WIDE_IMAGE':
      result.brandDefault = await setBrandDefaultMessageData(item);
      break;
    case 'BRANDTALK_WIDE_ITEM_LIST':
      result.brandWideItemList = await brandWideItemListToFrontend(item);
      break;
    case 'BRANDTALK_CAROUSEL_FEED':
      result.brandCarouselFeed = await brandCarouselFeedToFrontend(item);
      break;
    case 'BRANDTALK_CAROUSEL_COMMERCE':
      result.brandCarouselCommerce = await brandCarouselCommerceToFrontend(item);
      break;
    case 'BRANDTALK_COMMERCE':
      result.brandCommerce = await brandCommerceToFrontend(item);
      break;
    case 'BRANDTALK_PREMIUM_VIDEO':
      result.brandPremiumVideo = await brandPremiumVideoToFrontend(item);
      break;
    default:
      break;
  }

  return result;
};
